import React, { useEffect, useRef } from 'react'
import { TGetFilterVal } from './GenericFilters'
import { enumHLSearchDataType } from '../../VisualunitHelpers'
import { IBusinessParamsOptions } from '../Reports/VisualUnitParamsDialog'
import { IHLreturnData, updateDurationsFilterInputs } from '../VuParamsHelpers'
import { parseConvertedFilterDispText } from './ConvertFilterDisplayText'

const replaceFilterValueParameter_HLText = (
    replacedStr: any,
    listItemId: any,
    filterableId: any,
    filterValueListId: any,
    filterValue: string,
    GetFilterValues: (filterValArgs: TGetFilterVal) => void,
    selectedItem: string,
    selectedParameters: any,
    MetadataId: number
) => {
    const [HLTextValues, setHLTextValues] = React.useState<{HLTEXT: string | undefined}>({HLTEXT: undefined})

    const setInput = (key: string, value: any) => {
        let copyInputVal = { ...HLTextValues }
        copyInputVal = {
            ...copyInputVal,
            [key]: value == "" ? undefined : value,
        }
        setHLTextValues(copyInputVal)
        GetFilterValues({ displayText: filterValue, selectedValues: copyInputVal, keyValue: filterValueListId })
    }

    useEffect(() => {
        if (selectedItem != null) {
            GetFilterValues({ displayText: filterValue, selectedValues: HLTextValues, keyValue: filterValueListId })
        }
    }, [selectedItem])

    useEffect(() => {
        if (selectedParameters.data !== null) {
            if (selectedParameters.data.filterValueListId == filterValueListId && selectedParameters.data.metaDataId == MetadataId) {
                updateDurationsFilterInputs(setHLTextValues, "HLTEXT", selectedParameters)
            }
        }
    }, [])

    const getNonInputText = () =>{
        GetFilterValues({displayText: filterValue, selectedValues: "", keyValue: filterValueListId})
    }

    const parseReplacedStr = (str: string) => {
        const regex = new RegExp(`\\[(${enumHLSearchDataType.HLText})\\]`, 'gi'); 
        const parts = str.split(regex).filter(Boolean);
        if (parts.length === 1) {
            return (
                <span
                    key="plain-text"
                    onClick={()=>getNonInputText()}
                >
                    {parts[0]}
                </span>
            );
        }
        const jsxParts = parts.map((part, index) => {
            if (part === enumHLSearchDataType.HLText) {
                return (
                    <input
                        type="text"
                        id={`${listItemId}_${enumHLSearchDataType.HLText}`}
                        size={20}
                        maxLength={50}
                        defaultValue={HLTextValues.HLTEXT}
                        autoComplete="off"
                        className="filtervalue-input-free-text"
                        onChange={(e) => setInput(enumHLSearchDataType.HLText, e.target.value)}
                    />
                )
            }
            return part
        })
        return jsxParts
    }
    return <>{parseReplacedStr(replacedStr)}</>
}

export default replaceFilterValueParameter_HLText